import React from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import { SuperAdminTopTextSearchIcon } from "../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

export const SuperAdminMainComponent = () => {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="All Active Vendors" />
            <div className="super-admin-inside-right-side-panel">
              <div className="seating_dashboard_top_new_header">
                <div className="row">
                  <div className="col-6">
                    <h4>All Active Vendors</h4>
                  </div>
                  <div className="col-6 text-right">
                    <button
                      onClick={(e) => this.props.history.push("/addvendor")}
                      className="btn add_button_custom_1"
                    >
                      + Create Order
                    </button>
                  </div>
                </div>
              </div>
              <SuperAdminTopTextSearchIcon
              // showFilter={this.state.displayFilter}
              // handleShowFilter={this.handleShowFilter}
              // handleSaveButton={this.handleShowFilter}
              // onChange={this.onSearchChange}
              // search={this.state.search}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
